import { render, staticRenderFns } from "./PluginVersion.vue?vue&type=template&id=fa521b64&scoped=true&"
import script from "./PluginVersion.vue?vue&type=script&lang=js&"
export * from "./PluginVersion.vue?vue&type=script&lang=js&"
import style0 from "./PluginVersion.vue?vue&type=style&index=0&id=fa521b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa521b64",
  null
  
)

export default component.exports